module.exports = __webpack_public_path__ + "img/image00003.baebe042.jpeg";